import { remove } from "ts-invariant/process/index.js";
import { Source } from 'graphql';
export function removeTemporaryGlobals() {
    return typeof Source === "function" ? remove() : remove();
}
//# sourceMappingURL=fix-graphql.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@apollo/client/utilities/globals/fix-graphql.js
// module id = 1530
// module chunks = 4